import type { PropsWithChildren } from 'react';
import { BackgroundPriority } from '@atlassian/jira-non-critical/src/BackgroundPriority.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { useIsGlobalHydrationComplete } from '@atlassian/jira-ssr-controller/src/use-is-page-hydrating.tsx';

/**
 * Renders children when hydration has completed globally (all subtrees have hydrated).
 * Will never render children if page is not hydrated.
 */
const RenderAfterHydrationCompletionNew = ({ children }: PropsWithChildren) => {
	const isCompleted = useIsGlobalHydrationComplete();
	if (!isCompleted) {
		return null;
	}
	return children;
};

export const RenderAfterHydrationCompletion = componentWithCondition(
	() => fg('jfp-magma-fix-hydration-completion'),
	RenderAfterHydrationCompletionNew,
	BackgroundPriority,
);
